import styled from '@emotion/styled';
import {
  Step,
  StepConnector,
  stepConnectorClasses,
  StepLabel,
  Stepper,
  Typography,
} from '@mui/material';
import { Box } from '@mui/system';

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 8,
    left: `calc(-40%)`,
    right: `calc(40%)`,
  },
  // [`&.${stepConnectorClasses.active}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage:
  //       'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
  //   },
  // },
  // [`&.${stepConnectorClasses.completed}`]: {
  //   [`& .${stepConnectorClasses.line}`]: {
  //     backgroundImage:
  //       'linear-gradient( 95deg,rgb(242,113,33) 0%,rgb(233,64,87) 50%,rgb(138,35,135) 100%)',
  //   },
  // },

  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    width: '100%',
    padding: 0,
    margin: 0,
    border: 0,
    backgroundImage: 'linear-gradient(to right, blue 50%, green 100%)',
    borderRadius: 1,
  },
}));
interface IProps {
  step: 'chapterSelection' | 'settings' | undefined;
  step1ClickHandler: () => void;
  step2ClickHandler: () => void;
  disableStep1?: boolean;
  disableStep2?: boolean;
}
export const StepperComponent = (props: IProps) => {
  const {
    step,
    disableStep1,
    disableStep2,
    step1ClickHandler,
    step2ClickHandler,
  } = props;
  return (
    <Stepper
      alternativeLabel
      connector={
        <StepConnector
          sx={{
            top: 8,
            left: `calc(-40%)`,
            right: `calc(40%)`,
            width: '80%',
            height: '4px',
            backgroundImage:
              step === undefined
                ? 'linear-gradient(to right,#7EC6FD 0%, #7EC6FD 50%,#44FD97 50%, #44FD97 100%)'
                : step === 'chapterSelection'
                ? 'linear-gradient(to right,#007CDC 0%, #007CDC 50%, #B8E0FF 50%, #B8E0FF 100%)'
                : 'linear-gradient(to right,#007CDC 0%, #007CDC 50%,#03612D 50%, #03612D 100%)',
            transition: 'backgroundImage 0.5s ease-in-out',
            '& .MuiStepConnector-line': {
              borderColor: 'transparent',
            },
          }}
        />
      }
    >
      <Step
        sx={{ padding: 0, margin: 0 }}
        onClick={() => {
          if (!disableStep1) {
            step1ClickHandler();
          }
        }}
      >
        <StepLabel
          StepIconComponent={() => (
            <Box
              sx={{
                width: '22px',
                height: '22px',
                borderRadius: '22px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: step === undefined ? '#7EC6FD' : '#007CDC',
                cursor: 'pointer',
              }}
            >
              {step === undefined && (
                <Box
                  sx={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '18px',

                    backgroundColor: 'white',
                  }}
                />
              )}
            </Box>
          )}
        >
          <Typography
            variant="smallText"
            fontWeight="bold"
            sx={{ color: step === undefined ? '#0000005C' : '#333333' }}
          >
            Select Chapter
          </Typography>
        </StepLabel>
      </Step>
      <Step
        sx={{ padding: 0, margin: 0 }}
        onClick={() => {
          if (!disableStep2) {
            step2ClickHandler();
          }
        }}
      >
        <StepLabel
          StepIconComponent={() => (
            <Box
              sx={{
                width: '22px',
                height: '22px',
                borderRadius: '22px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: step === 'settings' ? '#03612D' : '#44FD97',
                cursor: 'pointer',
              }}
            >
              {step !== 'settings' && (
                <Box
                  sx={{
                    width: '18px',
                    height: '18px',
                    borderRadius: '18px',
                    backgroundColor: 'white',
                  }}
                />
              )}
            </Box>
          )}
        >
          <Typography
            variant="smallText"
            fontWeight="bold"
            sx={{ color: step === 'settings' ? '#333333' : '#0000005C' }}
          >
            Settings
          </Typography>
        </StepLabel>
      </Step>
    </Stepper>
  );
};

// import React, { useState } from 'react';

// import { Box, Button, Paper, Typography } from '@mui/material';
// import Check from '@mui/icons-material/Check';
// export const StepperComponent = () => {
//   const [currentStep, setCurrentStep] = useState(0);
//   const totalSteps = 2;

//   const handleStepClick = (stepIndex: number) => {
//     if (stepIndex <= currentStep + 1) {
//       setCurrentStep(stepIndex);
//     }
//   };

//   const StepCircle = ({
//     index,
//     isCompleted,
//     isActive,
//   }: {
//     index: number;
//     isCompleted: boolean;
//     isActive: boolean;
//   }) => (
//     <Box
//       role="button"
//       tabIndex={0}
//       onClick={() => handleStepClick(index)}
//       onKeyDown={(e) => e.key === 'Enter' && handleStepClick(index)}
//       sx={{
//         width: 48,
//         height: 48,
//         borderRadius: '50%',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         cursor: 'pointer',
//         transition: 'all 0.3s ease',
//         position: 'relative',
//         bgcolor: isCompleted
//           ? 'primary.main'
//           : isActive
//           ? 'primary.light'
//           : 'grey.300',
//         boxShadow: 3,
//         '&:hover': {
//           transform: 'scale(1.1)',
//         },
//       }}
//       aria-label={`Step ${index + 1} ${
//         isCompleted ? 'completed' : isActive ? 'current' : 'pending'
//       }`}
//     >
//       {isCompleted ? (
//         <Check style={{ color: 'white', fontSize: 20 }} />
//       ) : (
//         <Typography
//           variant="body1"
//           sx={{ color: isCompleted || isActive ? 'white' : 'grey.700' }}
//         >
//           {index + 1}
//         </Typography>
//       )}
//       <Typography
//         variant="caption"
//         sx={{ position: 'absolute', bottom: -24, color: 'grey.600' }}
//       >
//         Step {index + 1}
//       </Typography>
//     </Box>
//   );

//   const StepConnector = ({
//     isCompleted,
//     isPartial,
//   }: {
//     isCompleted: boolean;
//     isPartial: boolean;
//   }) => (
//     <Box
//       sx={{
//         position: 'relative',
//         width: 96,
//         height: 8,
//         mx: 1,
//       }}
//     >
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'grey.300',
//           borderRadius: 4,
//         }}
//       />
//       <Box
//         sx={{
//           position: 'absolute',
//           inset: 0,
//           bgcolor: 'primary.main',
//           width: isCompleted ? '100%' : isPartial ? '50%' : '0%',
//           borderRadius: 4,
//           transition: 'width 0.3s ease',
//         }}
//       />
//     </Box>
//   );

//   return (
//     <Box
//       sx={{
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//       }}
//     >
//       {Array.from({ length: totalSteps }).map((_, index) => (
//         <React.Fragment key={index}>
//           <StepCircle
//             index={index}
//             isCompleted={index < currentStep}
//             isActive={index === currentStep}
//           />
//           {index < totalSteps - 1 && (
//             <StepConnector
//               isCompleted={index < currentStep - 1}
//               isPartial={index === currentStep - 1}
//             />
//           )}
//         </React.Fragment>
//       ))}
//     </Box>
//   );
// };
